import { Avatar, Stack, Typography } from "@mui/material";
import WhiteCard from "src/shared/components/WhiteCard";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useIsMobile } from "src/hooks/useIsMobile";
import { truncateAfterWords } from "src/utils/truncateAfterWords";
import { Navigate, NavLink } from "react-router-dom";
import { useMessageThreads } from "src/context/MessageThreadsProvider";
import { useTranslation } from "react-i18next";

interface Props {
  active?: boolean;
}

const Messaging = ({ active = true }: Props) => {
  const { threads } = useMessageThreads(active);
  const page = "messaging";
  const { t } = useTranslation();

  const isMobile = useIsMobile();

  if (threads.length === 1) {
    return <Navigate to={`${threads[0].id}`} replace />;
  }

  return (
    <Stack gap={3} height={"100%"}>
      <Typography variant="h5" fontWeight={700}>
        {t(`${page}.header`)}
      </Typography>
      {threads.length === 0 ? (
        <Typography>
          {t(
            `${page}.message`,
            "You have no active message threads at the moment",
          )}
        </Typography>
      ) : (
        <Stack gap={2}>
          {threads.map((thread) => (
            <NavLink to={thread.id} key={thread.id}>
              <WhiteCard
                key={thread.id}
                direction="row"
                justifyContent="space-between"
              >
                <Stack gap={1}>
                  <Typography fontWeight={600}>
                    {thread.product_category.name} - {thread.product.name}
                  </Typography>
                  <Typography variant="subtitle2">
                    {truncateAfterWords(
                      thread.message ?? "",
                      isMobile ? 3 : 23,
                    )}
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  alignItems="center"
                  sx={{ cursor: "pointer" }}
                >
                  {thread.unreadTotal === 0 ? null : (
                    <Avatar
                      color="#ffffff"
                      sx={{
                        background: "#00B6B9",
                        width: 20,
                        height: 20,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        color="#ffffff"
                        fontSize="0.8rem"
                        fontWeight={600}
                      >
                        {thread.unreadTotal}
                      </Typography>
                    </Avatar>
                  )}
                  <NavigateNextIcon sx={{ color: "#6C7278" }} />
                </Stack>
              </WhiteCard>
            </NavLink>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default Messaging;
